import { Table } from '@/components_deprecated/Table'
import type {
  DriverActivityDayReportQueryReportData,
  DriverActivityReport,
} from '@/modules/activities/types.graphql'
import { enforceHourMinuteString } from '@/modules/activities/util'
import { Row } from './ActivitiesWeekTableRow'
import styled from 'styled-components'
import { useTranslate } from '@ur-solutions/react-hooks'

interface AllActivitiesSumTableProps {
  report?: DriverActivityReport | DriverActivityDayReportQueryReportData | null
}

const StyledTable = styled(Table)`
  margin-top: 1rem;
  tr {
    cursor: default;
  }
`

const StyledRow = styled(Row)`
  height: 14px;
`

export const AllActivitiesSumTable: React.JSX.CFC<
  AllActivitiesSumTableProps
> = ({ report }) => {
  const translations = useTranslate({
    paidPause: 'activities.paid-pause',
    field: 'common.field',
    sum: 'common.sum',
    totalWork: 'common.total-work',
    driverDiets: 'common.diet',
    salaryDays: 'common.salary-day',
  })
  const activitySums = report?.groupedActivitySums
  return (
    <StyledTable headerMargin rowHoverBackground="gray10">
      <thead>
        <tr>
          <th>{translations.field}</th>
          <th>{translations.sum}</th>
        </tr>
      </thead>
      <tbody>
        <StyledRow isActive={true} isAbsence={false} onClick={() => {}}>
          <td>{translations.totalWork}</td>
          <td>{enforceHourMinuteString(report?.timeWorkTotal)}</td>
        </StyledRow>

        {activitySums?.map(activitySum => (
          <StyledRow
            key={activitySum.id}
            isActive={true}
            isAbsence={false}
            onClick={() => {}}
          >
            <td>{activitySum.name}</td>
            <td>{enforceHourMinuteString(activitySum.sum)}</td>
          </StyledRow>
        ))}

        {report?.sumDriverDietsDetailed ? (
          report.sumDriverDietsDetailed.map(diet => (
            <StyledRow
              key={diet.name}
              isActive={true}
              isAbsence={false}
              onClick={() => {}}
            >
              <td>{diet.name}</td>
              <td>{diet.sum}</td>
            </StyledRow>
          ))
        ) : report?.sumDriverDiets ? (
          <StyledRow isActive={true} isAbsence={false} onClick={() => {}}>
            <td>{translations.driverDiets}</td>
            <td>{report.sumDriverDiets}</td>
          </StyledRow>
        ) : (
          <></>
        )}

        {report?.sumSalaryDaysDetailed ? (
          report.sumSalaryDaysDetailed.map(salaryDay => (
            <StyledRow
              key={salaryDay.name}
              isActive={true}
              isAbsence={false}
              onClick={() => {}}
            >
              <td>{salaryDay.name}</td>
              <td>{salaryDay.sum}</td>
            </StyledRow>
          ))
        ) : report?.sumSalaryDays ? (
          <StyledRow isActive={true} isAbsence={false} onClick={() => {}}>
            <td>{translations.salaryDays}</td>
            <td>{report.sumSalaryDays}</td>
          </StyledRow>
        ) : (
          <></>
        )}
      </tbody>
    </StyledTable>
  )
}
